import React from "react";

import { Action, Category } from "constants/events";
import { DispensaryV3 } from "custom-types/DispensariesV3";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import { useEventTracker } from "hooks/useEventTracker";
import { determineOrderMethod } from "utils/determineOrderMethod";
import { getRoundedDistance } from "utils/distance";
import { localizeText } from "utils/localizeText";

import DispensariesCarousel from "@/components/DispensariesCarousel";

const NewsDispensariesCarousel = () => {
  const countryCode = useDomainCountryCode();

  const { publishEvent } = useEventTracker();

  const trackCardImpression = (slot: number, dispensary: DispensaryV3) => {
    const eventLabel = determineOrderMethod(
      !!dispensary.flags.includes("pickup"),
      !!dispensary.flags.includes("delivery"),
      dispensary.tier,
      dispensary.flags,
    );

    publishEvent({
      action: Action.impression,
      category: Category.dispensaryCard,
      dispensaryDistance: getRoundedDistance(
        dispensary.distanceMi,
        countryCode,
      ),
      dispensaryId: dispensary?.id,
      label: `slot #${slot + 1}: ${eventLabel}`,
    });
  };

  const localizedText = localizeText("dispensaries", countryCode);
  return (
    <DispensariesCarousel
      cardsPerSlide={3}
      changeLocation={true}
      className="my-section -mx-lg md:mx-none"
      link="/dispensaries"
      linkText={`See all ${localizedText}`}
      page="news"
      subtitle={`Showing you ${localizedText} near`}
      title={`Shop highly rated ${localizedText} near you`}
      trackCardImpression={trackCardImpression}
    />
  );
};

export default NewsDispensariesCarousel;
